import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { css } from '@emotion/core'

const blockMargin = props => props.blockMargin && css`
  padding: 28px 13.33% 8px;
`
const Wrapper = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  
  width: 100%;
  height: 100%;
  
  ${blockMargin}
`

const Scrollable = ({
  children,
  blockMargin,
  isReverse,
  topLoadOffset,
  bottomLoadOffset,
  handleLoad,
  scrollToBottomRequired,
  scrollToTopRequired,
  scrollToBottomCallback,
  scrollToTopCallback
}) => {
  //ref logic
  let scrollRef

  //state logic
  const [anchored, setAnchored] = useState(false)
  const [isLoading, setLoadingState] = useState(false)
  const [beforeScrollHeight, setBeforeScrollHeight] = useState(0)
  const [beforeScrollTop, setBeforeScrollTop] = useState(0)

  useEffect(() => {
    if(
      isReverse &&
      !anchored &&
      scrollRef.scrollHeight > scrollRef.clientHeight
    ) {
      const lowestTopPosition = scrollRef.scrollHeight - scrollRef.clientHeight
      scrollRef.scrollTop = lowestTopPosition
      setAnchored(true)
    }

    if(
      isReverse &&
      isLoading &&
      scrollRef.scrollHeight > beforeScrollHeight
    ) {
      scrollRef.scrollTop =
        scrollRef.scrollHeight -
        beforeScrollHeight +
        beforeScrollTop

      setLoadingState(false)
    }

    if(scrollToBottomRequired) {
      setTimeout(() => {

        if(scrollRef) {
          // Delay for drawing the list
          scrollRef.scrollTop = scrollRef.scrollHeight
          scrollToBottomCallback && scrollToBottomCallback()
        }

      }, 200)
    }
    if(scrollToTopRequired) {
      setTimeout(() => {
        if(scrollRef) {
          scrollRef.scrollTop = 0
          scrollToTopCallback && scrollToTopCallback()
        }

      }, 200)
    }
  })

  const onWheel = e => {
    if (e.deltaY < 0) {
      // scrolling up
      const lowestTopPosition = scrollRef.scrollHeight - scrollRef.clientHeight
      const isFetchZone = scrollRef.scrollTop <= topLoadOffset * lowestTopPosition
      const reachTop = scrollRef.scrollTop === 0

      if(
        isFetchZone
        && isReverse
        && !reachTop
        && typeof handleLoad === 'function'
      ) {
        //updating state
        setBeforeScrollHeight(scrollRef.scrollHeight)
        setBeforeScrollTop(scrollRef.scrollTop)

        //calling load function
        handleLoad()
        setLoadingState(true)
      }
    } else if (e.deltaY > 0) {
      // scrolling down
      const lowestTopPosition = scrollRef.scrollHeight - scrollRef.clientHeight
      const isFetchZone = scrollRef.scrollTop >= bottomLoadOffset * lowestTopPosition
      const reachBottom = scrollRef.scrollTop === lowestTopPosition

      if(
        isFetchZone
        && !isReverse
        && !reachBottom
        && typeof handleLoad === 'function'
      ) {
        //updating state
        setBeforeScrollHeight(scrollRef.scrollHeight)
        setBeforeScrollTop(scrollRef.scrollTop)

        //calling load function
        handleLoad()
        setLoadingState(true)
      }
    }
  }

  return (
    <Wrapper
      ref={ref => scrollRef = ref}
      blockMargin={blockMargin}
      onWheel={onWheel}
    >
      { children }
    </Wrapper>
  )
}
Scrollable.defaultProps = {
  isReverse: false,
  blockMargin: false,
  topLoadOffset: 0.3,
  bottomLoadOffset: 0.7
}
Scrollable.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]),

  blockMargin: PropTypes.bool,
  isReverse: PropTypes.bool,

  topLoadOffset: PropTypes.number,
  bottomLoadOffset: PropTypes.number,
  handleLoad: PropTypes.func,

  scrollToBottomRequired: PropTypes.bool,
  scrollToTopRequired: PropTypes.bool,
  scrollToBottomCallback: PropTypes.func,
  scrollToTopCallback: PropTypes.func
}

export default Scrollable
